import { UserDto } from '../types/userTypes';

export const formatUserName = (user: UserDto) => {
	return `${user.name || user.email} ${user.name && user.surName ? user.surName : ''}`;
};

export const formatEmailList = (emailList: string) => {
	return emailList?.split(',')?.join(', ');
};
